import {
  Switch,
  LabelPosition,
  SwitchSize
} from "shared/components/forms/Switch";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent
} from "shared/components/Tooltip";
import {
  SUPPORT_AGENT_TOOLTIP,
  useSupportAgentState
} from "../hooks/useSupportAgentState";

// Toggles the Application Support Agent for the applicant tied to the current
// conversation. Defaults to on (the applicant column defaults to true).
export const SupportAgentToggle = ({
  applicantId,
  active,
  disabled = false,
  label = "Application Support Agent",
  onChanged
}: {
  applicantId: number;
  active: boolean;
  /** Row label — the pop-up passes the design's sentence-case variant. */
  label?: string;
  // Read-only surfaces (e.g. the scrimmed application-report chat preview) show
  // the current state without letting it be changed.
  disabled?: boolean;
  /**
   * Fired the moment the switch flips — BEFORE the PATCH — and again with the
   * previous value if the PATCH fails. Hosts that DERIVE `active` from a cached
   * query (the message pop-up reads it off the application) mirror the flip
   * into that cache here, so their own indicator moves with the switch instead
   * of lagging a round-trip behind it.
   */
  onChanged?: (active: boolean) => void;
}) => {
  const { agentActive, handleToggle } = useSupportAgentState({
    applicantId,
    active,
    onChanged
  });

  return (
    <Tooltip placement="bottom">
      <TooltipTrigger asChild>
        <div>
          <Switch
            checked={agentActive}
            label={label}
            onChange={handleToggle}
            position={LabelPosition.Left}
            size={SwitchSize.SM}
            disabled={disabled}
          />
        </div>
      </TooltipTrigger>
      <TooltipContent className="px-3 py-2 rounded-lg max-w-xs">
        <p className="text-white text-xs">
          {agentActive ? "Disable" : "Enable"} the application support agent for
          this chat. {SUPPORT_AGENT_TOOLTIP}
        </p>
      </TooltipContent>
    </Tooltip>
  );
};
